<template>
    <div>
        <div
            class="goToTop"
            @click="goToTop"
            v-show="isTop"
            >返回<br/>顶部</div>
        <div class="refresh" v-show="isRefreshShow" @click="refresh">刷新</div>
    </div>
</template>
<script>
export default {
    name:'goToTop',
    data(){
        return {
            isTop: false
        }
    },
    props:['isRefreshShow'],
    methods:{
        refresh() {
            // this.$router.replace({
            //     path: this.$router.path,
            //     query: {
            //         v: Math.random()
            //     }
            // })
            // location.reload()
            this.$emit('refresh')
        },
        goToTop() {
            let distance = document.documentElement.scrollTop || document.body.scrollTop; //获得当前高度
            let step = distance/60; //每步的距离
            (function jump(){
                if(distance > 0){
                    distance-=step;
                    window.scrollTo(0,distance);
                    setTimeout(jump,5)
                }
            })();
        },
    },
    mounted() {
        let _this = this
        window.addEventListener('scroll',function(){
            let sTop = document.documentElement.scrollTop || document.body.scrollTop
            sTop = parseInt(sTop);
            if (sTop >= 600) {
                _this.isTop = true
            }else {
                _this.isTop = false
            } 
        },false)
        window.signIn = () => {
            this.signIn()
        }
    }
}
</script>
<style scoped>
    .refresh,.goToTop{
        position: fixed;
        right: 0;
        bottom: 38px;
        width: 119px;
        height: 137px;
        background: url('../../../assets/img/base/refrsh111.png') no-repeat;
        background-size: 100%;
        text-align: center;
        line-height: 137px;
        font-size: 30px;
        color: #fff;
    }
    .goToTop{
        bottom: 160px;
        line-height: 30px;
        height: 100px;
        font-size: 26px;
        padding-top: 38px;
    }
</style>


// WEBPACK FOOTER //
// src/components/common/goToTop/goToTop.vue